<template>
  <div>
    <page-title icon="fa fa-shopping-cart" main="Produtos" sub="Pesquisar Produtos Preferenciais"
      :help="true" titleHelp="Ajuda - Produtos Preferenciais"
      content="Página responsável por listar produtos Preferenciais.
Produtos Preferenciais possuem um ou vários produtos vinculados.
Para criação pressione o botão no canto superior direito 'Novo Produto Preferencial'.
Para alteração de um produto preferencial basta ir com o mouse em ações e clicar em Editar."
    >
      <template v-slot:actions>
        <base-button
          @click="
            (preferredproduct = {}),
              (form.clone.preferredproduct = {}),
              (modals.modal0 = true)
          "
          type="neutral"
          class="ml-3"
          size="sm"
          >Novo Produto Preferencial</base-button
        >
      </template>
    </page-title>
    <!-- Preferred Product form modal -->
    <go-back-modal :title="goBackModalTitle" :open="openGoBackModal" />
    <modal :show.sync="modals.modal0" id="cadastrar-grupo" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">
          Cadastrar Novo Produto Preferencial
        </h5>
      </template>
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form role="form" @submit.prevent="handleSubmit(save)">
          <div class="row">
            <div class="col-md-4">
              <label class="form-control-label">Copiar Produto Existente</label>
              <multiselect
                class="mb-3"
                :options="form.clone.products"
                placeholder="Copiar Produto"
                v-model="form.clone.preferredproduct"
                label="description"
                track-by="id"
                :loading="form.clone.isLoading"
                @search-change="updateClonePreferredproducts"
                @select="cloneProduct"
                @remove="preferredproduct = {}"
              ></multiselect>
            </div>
            <div class="col-md-4">
              <label class="form-control-label">Nome</label>
                <base-input
                  group
                  class="mb-3"
                  :valid="true"
                  type="text"
                  placeholder="Nome do Produto"
                  v-model="preferredproduct.name"
                  aria-label="Nome do Produto"
                  rules="required"
                  success-message="Campo preenchido"
                ></base-input>
            </div>
            <div class="col-md-4">
              <label class="form-control-label">Marca</label>
              <ValidationProvider
                vid="brand"
                name="Marca"
                rules="required"
                v-slot="{ errors }"
              >
                <multiselect
                  class="mb-3"
                  :valid="true"
                  :options="brands"
                  placeholder="Marca do Produto"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  v-model="preferredproduct.brand"
                  aria-label="Marca do Produto"
                  rules="required"
                  success-message="Campo preenchido"
                  :error="errors[0]"
                  label="name"
                  track-by="id"
                ></multiselect>
              </ValidationProvider>
            </div>
          </div>
          <div class="row"></div>
          <div class="row">
            <div class="col-md-6">
              <div :class="{ invalid: groupIsInvalid }">
                <label class="form-control-label">Grupo</label>
                <multiselect
                  v-model="preferredproduct.grupo"
                  :options="grupos"
                  :disabled="true"
                  placeholder="Selecionar Grupo"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  label="descricao"
                  track-by="id"
                  :allow-empty="true"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('group')"
                >
                  <template v-slot:noResult
                    >Nenhum Resultado Encontrado</template
                  >
                </multiselect>
              </div>
            </div>
            <div class="col-md-6">
              <div :class="{ invalid: subGroupIsInvalid }">
                <label class="form-control-label">Sub-Grupo</label>
                <multiselect
                  v-model="preferredproduct.subgrupo"
                  :options="subgrupo"
                  :disabled="true"
                  placeholder="Selecionar Sub-Grupo"
                  label="descricao"
                  :select-label="''"
                  :deselect-label="''"
                  :selected-label="'Selecionado'"
                  track-by="id"
                  :allow-empty="true"
                  :block-keys="['Tab', 'Enter']"
                  @close="onTouch('subgroup')"
                >
                  <template v-slot:noResult
                    >Nenhum Resultado Encontrado</template
                  >
                </multiselect>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal0 = false"
          >Fechar</base-button
        >
        <base-button
          type="success"
          :disabled="isSaving"
          v-loading="isSaving"
          @click="save"
          >Salvar e Continuar</base-button
        >
      </template>
    </modal>
    <modal :show.sync="modals.modal1" id="editar-grupo" size="lg">
      <template slot="header">
        <h5 class="modal-title p-4" id="exampleModalLabel">
          Editar Produto Existente
        </h5>
      </template>
      <form role="form" @submit.prevent="ExecEdit">
        <div class="row">
          <div class="col-md-6 p-4">
            <base-input
              label="Nome"
              placeholder="Nome do Produto"
              v-model="formPreferredProduct.name"
              :required="true"
              name="name"
            />
          </div>
          <div class="col-md-6 p-4">
            <label class="form-control-label d-block mb-3">Marca</label>
            <multiselect
              v-model="formPreferredProduct.brand"
              :options="brands"
              placeholder="Selecionar Marca"
              label="name"
              :allow-empty="true"
              track-by="id"
            >
            </multiselect>
          </div>
          <div class="col-md-6 p-4">
            <label class="form-control-label d-block mb-3">Grupo</label>
            <multiselect
              v-model="formPreferredProduct.grupo"
              :options="productsGroups"
              placeholder="Selecionar Grupo"
              label="descricao"
              track-by="id"
              :disabled="formPreferredProduct.grupo && !preferredproduct.products_with_divergent_group"
            >
              <template v-slot:noResult>Nenhum Resultado Encontrado</template>
            </multiselect>
          </div>
          <div class="col-md-6 p-4">
            <label class="form-control-label d-block mb-3">Subgrupo</label>
            <multiselect
              v-model="formPreferredProduct.subgrupo"
              :options="subgrupo"
              placeholder="Selecionar Sub-Grupo"
              label="descricao"
              track-by="id"
            >
              <template v-slot:noResult>Nenhum Resultado Encontrado</template>
            </multiselect>
          </div>
        </div>
      </form>
      <br>
      <br>
      <template slot="footer">
        <base-button type="secondary" @click="modals.modal1 = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="execEdit">Salvar</base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal2" id="cadastrar-grupo" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Vincular Produtos</h5>
      </template>
      <template>
        <vue-list-picker
          @move-right="adicionaraopp(preferredproduct.id, $event)"
          @move-left="removerdopp(preferredproduct.id, $event)"
          @move-all-right="adicionaraopp(preferredproduct.id, $event)"
          @move-all-left="removerdopp(preferredproduct.id, $event)"
          @search-action-left="searchEventLeft($event)"
          @search-action-right="searchEventRight($event, preferredproduct.id)"
          :left-items="products"
          :right-items="rightItems"
          :title-right="preferredproduct.name"
          :left-search="true"
          :righ-search="true"
          right-search-placeholder="Informe o nome de um produto"
          left-search-placeholder="Informe o nome de um produto"
          content-key="id"
          content-attr="description"
          title-left="PRODUTOS"
          content-class="itensGrupos"
          title-class="tituloGrupos"
          button-class="btn btn-success button-class"
        >
          <template v-slot:tooltip="{ item }">
            {{ item.code + ' - ' + item.description}}
          </template>
        </vue-list-picker>
      </template>
      <div class="row">
        <div class="col-md-6">
          <div slot="footer" class="py-4 justify-content-end">
            <base-pagination
              v-on:input="changePageLeft"
              v-model="paginated_products_left['current']"
              :total="paginated_products_left['count']"
              :perPage="paginated_products_left['per_page']"
            ></base-pagination>
          </div>
        </div>
        <div class="col-md-6">
          <div slot="footer" class="py-4 d-flex justify-content-end">
            <base-pagination
              v-on:input="changePageRight(preferredproduct.id, $event)"
              v-model="paginated_products_right['current']"
              :total="paginated_products_right['count']"
              :perPage="paginated_products_right['per_page']"
            ></base-pagination>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="success"
          @click="(modals.modal2 = false), (product = {})"
          >Concluir</base-button
        >
      </template>
    </modal>
    <modal :show.sync="modals.modal3" id="vincular-culturas" size="lg">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Vincular Culturas</h5>
      </template>
      <template>
        <vue-list-picker
          v-on:move-right="addCulture(preferredproduct.id, $event)"
          v-on:move-left="removeCulture(preferredproduct.id, $event)"
          v-on:move-all-right="addCulture(preferredproduct.id, $event)"
          v-on:move-all-left="removeCulture(preferredproduct.id, $event)"
          :left-items="cultures"
          :right-items="rightItems"
          :content-key="'id'"
          :rightSearchPlaceholder="'Digite o nome de um produto'"
          :leftSearchPlaceholder="'Digite o nome de um produto'" 
          :content-attr="'description'"
          :title-left="'CULTURAS'"
          :title-right="preferredproduct.name"
          :content-class="'itensGrupos'"
          :title-class="'tituloGrupos'"
          :button-class="'btn btn-success button-class'"
          :leftSearch="true"
          v-on:search-action-left="searchEventLeftCultures($event, preferredproduct.id)"
          :rightSearch="true"
          v-on:search-action-right="searchEventRightCultures($event, preferredproduct.id)"
        />
      </template>
      <div class="row">
        <div class="col-md-6">
          <div slot="footer" class="py-4 justify-content-end">
            <base-pagination
              v-on:input="
                changePageLeftCultures(preferredproduct.id, $event, filterCultures)
              "
              v-model="paginated_cultures_left['current']"
              :total="paginated_cultures_left['count']"
              :perPage="paginated_cultures_left['per_page']"
            ></base-pagination>
          </div>
        </div>
        <div class="col-md-6">
          <div slot="footer" class="py-4 d-flex justify-content-end">
            <base-pagination
              v-on:input="
                changePageRightCultures(preferredproduct.id, $event, filterCulturesRight)
              "
              v-model="paginated_cultures_right['current']"
              :total="paginated_cultures_right['count']"
              :perPage="paginated_cultures_right['per_page']"
            ></base-pagination>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="success"
          @click="(modals.modal3 = false), (product = {})"
          >Concluir</base-button
        >
      </template>
    </modal>
    <!-- Product Edition Modal -->
    <modal :show.sync="modals.productEdition" size="lg">
      <h5 slot="header" class="modal-title" id="exampleModalLabel">
        Editar Produtos
      </h5>
      <div class="row">
        <div class="col-md-6">
          <strong>Descrição:</strong> {{ form.product.description }}<br />
          <strong>SIAGRI:</strong> {{ form.product.code }}<br />
          <strong>Marca:</strong> {{ form.product.brand }}<br />
          <strong>Unidade:</strong> {{ form.product.unity }}<br />
        </div>
        <div class="col-md-6">
          <strong>Volume da Unidade:</strong> {{ form.product.unity_volume }}<br />
          <strong>Peso (KG):</strong> {{ form.product.weight }}<br />
          <strong>Tipo unidade SGV:</strong>
          {{ unityVolumeTranslator }}<br />
        </div>
      </div>
      <br /><br />
      <div class="row">
        <div class="col-6">
          <label class="form-control-label">Tipo unidade SGV</label>
          <multiselect
            v-model="formProductUnity"
            :options="unityTypes"
            placeholder="SELECIONE O TIPO DE UNIDADE"
            label="name"
            track-by="code"
          ></multiselect>
        </div>
        <div class="col-6">
          <label class="form-control-label">Unidade SGV</label>
          <base-input
            rules="required"
            v-model="form.product.unity_volume"
            placeholder="Unidade SGV"
            type="number"
            step="0.1"
          ></base-input>
        </div>
        <div class="col-6">
          <base-switch
            v-model="formProductStatus"
            :label="formProductStatus ? 'Ativo' : 'Inativo'"
          ></base-switch>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="modals.productEdition = false"
          >Fechar</base-button
        >
        <base-button
          type="success"
          :disabled="isSaving"
          v-loading="isSaving"
          @click="saveProduct"
          >Salvar</base-button
        >
      </template>
    </modal>
    <!-- Product Inactivation Modal -->
    <modal :show.sync="modals.inactivateProduct">
      <h5 slot="header" class="modal-title" id="exampleModalLabel">
        Inativar Produto Preferencial
      </h5>
      <span>
        Ao inativar o Produto Preferencial
        <b class="text-danger"> {{ preferredproduct.name }} </b> você irá
        inativar seus produtos associados e
        <b class="text-danger">apagar</b> todas as metas associadas a ele a
        partir do Anosafra que você selecionar no campo abaixo:
      </span>
      <br />
      <br />

      <multiselect
        v-model="selectedAnosafra"
        :options="openAnosafras"
        placeholder=""
        label="descricao"
        track-by="id"
        :loading="isLoadingOpenAnosafras"
      />
      <template slot="footer">
        <base-button type="secondary" @click="modals.inactivateProduct = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="inactivate()">Salvar</base-button>
      </template>
    </modal>
    <modal :show.sync="modals.inactivateProduct">
      <h5 slot="header" class="modal-title" id="exampleModalLabel">
        Inativar Produto Preferencial
      </h5>
      <span>
        Ao inativar o Produto Preferencial
        <b class="text-danger"> {{ formPreferredProduct.name }} </b> você irá
        inativar seus produtos associados e
        <b class="text-danger">apagar</b> todas as metas associadas a ele a
        partir do Anosafra que você selecionar no campo abaixo:
      </span>
      <br />
      <br />

      <multiselect
        v-model="selectedAnosafra"
        :options="openAnosafras"
        placeholder=""
        label="descricao"
        track-by="id"
        :loading="isLoadingOpenAnosafras"
      />
      <template slot="footer">
        <base-button type="secondary" @click="modals.inactivateProduct = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="inactivate()">Salvar</base-button>
      </template>
    </modal>
    <card>
      <div slot="header">
        <span>Pesquisar Produtos Preferenciais</span>
      </div>
      <form>
        <div class="row">
          <div class="col-md-3">
            <div>
              <label class="form-control-label">Codigo do Produto</label>
              <multiselect
                v-model="filter.idObj"
                :options="preferredproducts"
                placeholder="Codigo do produto"
                :loading="loadPreferredProducts"
                label="id"
                track-by="id"
              >
                <template v-slot:noResult>Nenhum Resultado Encontrado</template>
              </multiselect>
            </div>
          </div>
          <div class="col-md-6">
            <base-input label="Descrição" v-model="filter.name"></base-input>
          </div>
          <div class="col-md-3">
            <label class="form-control-label">Status</label>
            <multiselect
              v-model="filter.selectedStatus"
              :options="filterStatuses"
              select-label=""
              deselect-label=""
              selected-label=""
              placeholder="Selecionar Status"
              label="label"
              track-by="value"
              :allow-empty="true"
              :preserveSearch="true"
              @input="teste($event)"
            >
              <template v-slot:noResult>Nenhum Resultado Encontrado</template>
            </multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div>
              <label class="form-control-label">Marca do Produto</label>
              <multiselect
                v-model="brandObj"
                :options="brands"
                placeholder="Selecionar Marca"
                label="name"
                :allow-empty="true"
                track-by="id"
              >
                <template v-slot:noResult>Nenhum Resultado Encontrado</template>
              </multiselect>
            </div>
            <!--<base-input label="Marca" v-model="filter.brand"></base-input>-->
          </div>
          <div class="col-md-4">
            <!--<base-input label="Grupo" v-model="filter.group">
              <select class="form-control"></select>
            </base-input>-->
            <div>
              <label class="form-control-label">Grupo</label>
              <multiselect
                v-model="filter.grupo"
                :options="grupos"
                :value="filter.grupo_id"
                placeholder="Selecionar Grupo"
                label="descricao"
                :allow-empty="true"
                track-by="descricao"
              >
                <template v-slot:noResult>Nenhum Resultado Encontrado</template>
              </multiselect>
            </div>
          </div>
          <div class="col-md-4">
            <!--<base-input label="Subgrupo" v-model="filter.subgroup">
              <select class="form-control"></select>
            </base-input>-->
            <div>
              <label class="form-control-label">Subgrupo</label>
              <multiselect
                v-model="filter.subgrupo"
                :options="subgrupo"
                placeholder="Selecionar Sub-Grupo"
                label="descricao"
                track-by="descricao"
                :allow-empty="true"
                :preserveSearch="true"
                @input="teste($event)"
              >
                <template v-slot:noResult>Nenhum Resultado Encontrado</template>
              </multiselect>
            </div>
          </div>
        </div>
        <div class="row justify-content-end mr-1">
          <div class="mr-2 mt-4">
            <base-button
              icon
              type="primary"
              :disabled="isLoading"
              v-loading="isLoading"
              v-on:click="search"
            >
              <span class="btn-inner--icon">
                <i class="fa fa-search"></i>
              </span>
              <span class="btn-inner--text">Pesquisar</span>
            </base-button>
          </div>
          <div class="mt-4">
            <base-button
              icon
              type="secondary"
              :disabled="isLoading"
              v-loading="isLoading"
              v-on:click="clearFilters"
            >Limpar Pesquisa
            </base-button>
          </div>
        </div>
      </form>
      <el-table
        v-loading="isLoading"
        empty-text="Nenhum produto preferencial encontrado."
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        style="width: 100% !important; padding-top: 10px"
        :data="preferredproductfilter"
        ref="preferredproducts"
      >
        <el-table-column
          label="Código"
          min-width="100px"
          prop="id"
          sortable
        ></el-table-column>
        <!-- TODO: Trocar id pelo code -->
        <el-table-column
          v-slot="{ row }"
          label="Descrição"
          min-width="160px"
          prop="name"
          sortable
        >
          <div slot="reference" class="name-wrapper">
            <p class="mb-0">{{ row.name }}</p>
            <badge type="warning" size="sm" v-if="!row.is_frozen">
              <i class="fas fa-exclamation-triangle"></i>
              Metas sujeitas a variação de preço
            </badge>
          </div>
        </el-table-column>
        <el-table-column
          label="Marca"
          min-width="130px"
          prop="brand.name"
          sortable
        ></el-table-column>
        <el-table-column
          label="Grupo"
          min-width="130px"
          prop="grupo.descricao"
          sortable
        ></el-table-column>
        <el-table-column
          label="Sub-Grupo"
          min-width="130px"
          prop="subgrupo.descricao"
          sortable
        ></el-table-column>
        <el-table-column
          label="Ações"
          min-width="120px"
          prop="acoes"
          v-slot="{ row }"
        >
          <div class="row">
            <el-dropdown
              trigger="hover"
              class="dropdown"
              style="cursor: pointer"
            >
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fa fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu
                class="dropdown-menu dropdown-menu-arrow show"
                slot="dropdown"
              >
                <a class="dropdown-item" href="#" @click="edit(row)">Editar</a>
                <a class="dropdown-item" href="#" @click="edit(row, true)"
                  >Vincular Produtos</a
                >
                <a
                  class="dropdown-item"
                  href="#"
                  @click="linkCulturesInPreferredProducts(row)"
                  >Vincular Culturas</a
                >
                <div v-if="getStatusById(row.id) === 'active'"> 
                  <a
                    class="dropdown-item"
                    href="#"
                    @click="showInactivateModal(row)"
                    >Inativar Produto Preferencial</a
                  >
                </div>
                <div v-if="getStatusById(row.id) === 'inactive'">
                  <a
                    class="dropdown-item"
                    href="#"
                    @click="activate(row)"
                    >Reativar Produto Preferencial</a
                  >
                </div>
                <a class="dropdown-item" href="#" @click="remove(row)"
                  >Excluir</a
                >
              </el-dropdown-menu>
            </el-dropdown>
            <a @click="rowClicked(row, true)">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fa fa-eye mt-2"></i>
              </span>
            </a>
          </div>
        </el-table-column>
        <el-table-column :min-width="1" type="expand">
          <template align="right">
            <div class="card-deck">
              <card>
                <h5 class="card-title">Culturas Vinculadas</h5>
                <div v-if="cultures" class="tags-input__wrapper">
                  <el-tag
                    v-for="(tag, index) in cultures"
                    :key="index"
                    size="mini"
                    effect="dark"
                    :closable="false"
                    class="tagproduto"
                    >{{ tag.description }}</el-tag
                  >
                </div>
              </card>
              <card>
                <h5 class="card-title">Produtos Vinculados</h5>
                <el-collapse-transition>
                  <div v-if="rowExpanded" class="tags-input__wrapper">
                    <el-popover
                      v-for="product in rowExpanded.products"
                      :key="product.id"
                      placement="top"
                      trigger="hover"
                    >
                      <div class="el-popover__title">
                        {{ product.description }}
                      </div>
                      <strong>SIAGRI:</strong> {{ product.code }}<br />
                      <strong>Marca:</strong> {{ product.brand }}<br />
                      <strong>Peso (KG):</strong> {{ product.weight }}<br />
                      <strong>Unidade:</strong> {{ product.unity }}<br />
                      <strong>Tipo Unidade SGV:</strong>
                      {{ unityVolumeTranslator(product.unity_type) }}<br />
                      <strong>Volume da Unidade:</strong>
                      {{ product.unity_volume }}<br />
                      <el-tag
                        slot="reference"
                        size="mini"
                        effect="dark"
                        :closable="false"
                        style="cursor: pointer"
                        class="tagproduto"
                        @click="editProduct(product)"
                        >{{ product.description }}</el-tag
                      >
                    </el-popover>
                  </div>
                </el-collapse-transition>
              </card>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="search"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        />
      </div>
    </card>
  </div>
</template>
<script>
import swal from "sweetalert2";
import {
  Tag,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Popover,
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import TagsInput from "@/components/Inputs/TagsInput";
import VueListPicker from "@/components/Vue-list-picker/VueListPicker";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import GoBackModal from "@/components/GoBackModal.vue";
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';


import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

import { mapState, mapActions } from 'vuex';

export default {
  name: "app",
  components: {
    props: ["placeholder"],
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    PageTitle,
    TagsInput,
    Tag,
    Multiselect,
    VueListPicker,
    ValidationProvider,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Popover.name]: Popover,
    GoBackModal,
    [CollapseTransition.name]: CollapseTransition
  },
  data() {
    return {
      modals: {
        modal0: false,
        modal1: false,
        modal2: false,
        modal3: false,
        productEdition: false,
        inactivateProduct: false,
      },
      form: {
        clone: {
          preferredproducts: [],
          products: [],
          preferredproduct: {},
          isLoading: false,
        },
        product: {},
      },
      rowExpanded: {},
      loadPreferredProducts: false,
      cultures: [],
      paginated_cultures_left: [],
      paginated_cultures_right: [],
      filterCultures: {},
      filterCulturesRight: {},
      isTouchedGroup: false,
      isTouchedSubgroup: false,
      filterSelects: {},
      preferredproductfilter: [],
      filter: {
        selectedStatus: {},
      },
      filterProduct: {},
      filterRight: {},
      filterStatuses: [
        { label: "Ativo", value: "active" },
        { label: "Inativo", value: "inactive" },
        { label: "Todos", value: "all" },
      ],
      errors: [],
      products: [],
      rightItems: [],
      paginated_products_left: {},
      paginated_products_right: {},
      preferredproduct: {},
      preferredproducts_brands: [],
      brands: [],
      grupos: [],
      subgrupo: [],
      productsGroups: [],

      // flag de verificação se foi pesquisado algo
      filtered: false,
      preferredproducts: [],
      paginated_data: [],
      openAnosafras: [],
      selectedAnosafra: {},
      isLoadingOpenAnosafras: false,
      isSaving: false,
      isLoading: false,
      unityTypes: [
        { code: "D", name: "DOSE" },
        { code: "M", name: "MX" },
        { code: "UN", name: "UN", otherOptions: ["U"] },
        { code: "KG", name: "KG/LT", otherOptions: ["KG", "LT", "GL", "FR", "K", "BD"] }
      ],
      formPreferredProduct: {},
      goBackModalTitle: "Produto preferencial não encontrado!",
      openGoBackModal: false,
      searchEventLeftTimeout: null,
      searchEventRightTimeout: null,
      loadingPickerProducts: false,
      brandObj: null
    };
  },
  created() {
    this.loadbrands();
    this.loadgrupos();
    this.loadsubgrupo();

    if (this.$route.params.id) {
      this.initRouteProduct(this.$route.params.id);
    } else {
      this.setData();
    }
  },
  methods: {
    getStatusById(id) {
      const product = this.preferredproductfilter.find(item => item.id === id);
      return product ? product.status : null;
    },
    ...mapActions(['resetNotificationAction']),
    rowClicked(row, ok) {
      if (ok === true) {
        if (this.rowExpanded === row) {
          this.$refs.preferredproducts.toggleRowExpansion(row, false);
          this.rowExpanded = null;
          this.cultures = null;
          return;
        }
        if (this.rowExpanded !== null) {
          this.$refs.preferredproducts.toggleRowExpansion(
            this.rowExpanded,
            false
          );
        }
        this.$refs.preferredproducts.toggleRowExpansion(row, true);
        this.rowExpanded = row;
        this.setCultures(row);
      }
    },
    setCultures(row) {
      this.cultures = row.cultures;
    },
    checkStatus() {
      if (this.preferredproductfilter.status == 'active') {
        return true
      }
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    async setFilterPreferredProducts() {
      try {
        const response =  await this.$http.secured.get(`/api/v2/preferredproducts`);
        this.preferredproducts = response.data.data;
      } catch (error) {
        console.log(error)
      }
    },
    async setData(q, page) {
      this.isLoading = true;
      try {
        if (typeof page === "undefined") page = null;
        if (typeof q === "undefined" || this.emptyFilter) q = null;

        for (const key in q) {
          if (q[key] === "") {
            delete q[key];
          }
        }
        const response = await this.$http.secured.get("/api/v1/preferredproducts", {
          params: {
            page: page,
            q: q,
          },
        });
        this.preferredproductfilter = response.data["preferredproducts"];
        if (this.preferredproducts.length === 0) {
          this.preferredproducts = this.preferredproductfilter;
        }
        this.paginated_data = response.data;
      } catch (error) {
        this.setError(error, "Something went wrong");
      } finally {
        this.isLoading = false;
      }
    },
    setStaticData() {
      this.setPreferredproducts();
    },
    loadbrands() {
      this.$http.secured
        .get("/api/v1/brands", {
          params: {
            unpaged: true,
          },
        })
        .then((response) => {
          this.brands = response.data;
        });
    },
    addCulture(preferredproduct_id, cultures) {
      var preferredproduct = {};
      preferredproduct.id = preferredproduct_id;

      if (Array.isArray(cultures)) {
        cultures.forEach((culture) => {
          preferredproduct.cultures_attributes = culture;
          this.$http.secured
            .put(`/api/v1/preferredproducts/${preferredproduct.id}`, {
              id: preferredproduct_id,
              cultures_attributes: culture,
            })
            .then((response) => {
              this.response = response.data;
              this.getCultures(
                preferredproduct.id,
                undefined,
                "left",
                "",
                null
              );
              this.getCultures(
                preferredproduct.id,
                undefined,
                "right",
                null,
                ""
              );
              this.$toasted.global.defaultSuccess({
                msg: "Culturas adicionadas com Sucesso!",
              });
            })
            .catch(() => {
              this.$toasted.global.defaultError({
                msg: "Não foi possivel adicionar as Culturas",
              });
            });
        });
      } else {
        preferredproduct.cultures_attributes = cultures;
        this.$http.secured
          .put(
            `/api/v1/preferredproducts/${preferredproduct.id}`,
            preferredproduct
          )
          .then((response) => {
            this.response = response.data;
            this.getCultures(preferredproduct.id, undefined, "left", "", null);
            this.getCultures(preferredproduct.id, undefined, "right", null, "");
            this.$toasted.global.defaultSuccess({
              msg: "Cultura adicionada com Sucesso!",
            });
          })
          .catch(() => {
            this.$toasted.global.defaultError({
              msg: "Não foi possivel adicionar a Cultura",
            });
          });
      }
    },
    removeCulture(preferredproduct_id, cultures) {
      var preferredproduct = {};
      preferredproduct.id = preferredproduct_id;

      if (Array.isArray(cultures)) {
        cultures.forEach((culture) => {
          preferredproduct.cultures_attributes = culture;
          this.$http.secured
            .post(`/api/v1/removeculturepreferred`, {
              id: preferredproduct_id,
              cultures_attributes: culture,
            })
            .then((response) => {
              this.response = response.data;
              this.getCultures(
                preferredproduct.id,
                undefined,
                "left",
                "",
                null
              );
              this.getCultures(
                preferredproduct.id,
                undefined,
                "right",
                null,
                ""
              );
              this.$toasted.global.defaultSuccess({
                msg: "Culturas removidas com Sucesso!",
              });
            })
            .catch((error) => {
              this.$toasted.global.defaultError({
                msg: "Não foi possivel remover as Culturas",
              });
            });
        });
      } else {
        preferredproduct.cultures_attributes = cultures;
        this.$http.secured
          .post(`/api/v1/removeculturepreferred`, preferredproduct)
          .then((response) => {
            this.response = response.data;
            this.getCultures(preferredproduct.id, undefined, "left", "", null);
            this.getCultures(preferredproduct.id, undefined, "right", null, "");
            this.$toasted.global.defaultSuccess({msg: "Cultura removida com Sucesso!",});
          })
          .catch((error) => {
            this.$toasted.global.defaultError({
              msg: "Não foi possivel remover a Cultura",
            });
          });
      }
    },
    loadgrupos() {
      this.$http.secured.get("/api/v1/grupos").then((response) => {
        this.grupos = response.data;
      });
    },
    loadsubgrupo() {
      this.$http.secured.get("/api/v1/subgrupos").then((response) => {
        this.subgrupo = response.data;
      });
    },

    setPreferredproducts() {
      this.loadPreferredProducts = true;
      this.$http.secured
        .get("/api/v1/preferredproducts", { params: { unpaged: true } })
        .then((response) => {
          this.preferredproducts = response.data;
          this.loadPreferredProducts = false;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    search(page) {
      const keysToDelete = ["subgrupo_id", "grupo_id", "brand", "id", "status"];
      keysToDelete.forEach((key) => delete this.filter[key]);

      if (this.filter.subgrupo) this.filter.subgrupo_id = this.filter.subgrupo.id;
      if (this.filter.grupo) this.filter.grupo_id = this.filter.grupo.id;
      if (this.brandObj) this.filter.brand = this.brandObj.name;
      if (this.filter.idObj) this.filter.id = this.filter.idObj.id;
      if ( this.filter.selectedStatus && this.filter.selectedStatus.value) {
        this.filter.status = this.filter.selectedStatus.value;
        delete this.filter.selectedStatus;
      }

      const query = Object.entries(this.filter)
        .filter(
          ([_, value]) =>
            typeof value !== "object" && value !== undefined && value !== null
        )
        .reduce((obj, [key, value]) => {
          obj[key] = value;
          return obj;
        }, {});

      this.filtered = Object.keys(query).length > 0;
      this.setData(query, page);
    },
    changePage(page) {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      // Se algo foi pesquisado passa o parametro de filtro
      // Se não é passado parâmetro nulo
      this.setData(filterInput, page);
    },
    async save() {
      if (!this.preferredproduct.name)
        return this.$toasted.global.defaultError({
          msg: "Nome não pode ficar em branco!",
        });
      if (!this.preferredproduct.brand)
        return this.$toasted.global.defaultError({
          msg: "Insira uma marca para a associação com produto preferencial !",
        });
      this.isSaving = true;
      const { grupo, subgrupo, brand, ...preferredproduct } = this.preferredproduct 
      const data = {
        preferredproduct: preferredproduct,
      };
      const response = await this.$http.secured.post(
        "/api/v1/preferredproducts",
        data
      );

      this.preferredproducts.push(response.data);
      this.$toasted.global.defaultSuccess();
      this.modals.modal0 = false;
      this.preferredproduct.id = response.data.id;
      this.edit(response.data, true);

      this.setData(null, null);
      this.isSaving = false;
    },
    async execEdit() {
   
      if (this.formPreferredProduct.brand_id || this.formPreferredProduct.brand) {
        this.formPreferredProduct.brand_id =
          this.formPreferredProduct.brand_id || this.formPreferredProduct.brand.id;
      }

      try {
        const response = await this.$http.secured.put(
          `/api/v1/preferredproducts/${this.formPreferredProduct.id}`,
          {
            preferredproduct: this.formPreferredProduct,
            anosafra_id: this.selectedAnosafra.id, 
          }
        );

        this.response = response.data; 

        this.$toasted.global.defaultSuccess("Produto ativado com sucesso!");

        this.modals.modal1 = false;
        this.formPreferredProduct = {};

      } catch (error) {
        console.error("Erro ao atualizar o produto preferencial: ", error);
        this.$toasted.global.defaultError("Erro ao atualizar o produto preferencial.");
      }
    },

    edit(preferredproduct, product) {
      this.preferredproduct = preferredproduct;
      this.formPreferredProduct = Object.assign({}, preferredproduct);
      this.productsGroups = this.grupos.filter((el) => preferredproduct.products_group_ids.includes(el.id));

      if (product) {
        this.setProducts("left", this.filterProduct);
        this.setProducts("right", preferredproduct.id);
        this.modals.modal2 = true;
      } else {
        this.modals.modal1 = true;
      }
    },

    linkCulturesInPreferredProducts(row) {
      this.preferredproduct = row;
      this.getCultures(row.id, undefined, "left", "", null);
      this.getCultures(row.id, undefined, "right", null);

      this.modals.modal3 = true;
    },
    async getOpenAnosafras() {
      this.isLoadingOpenAnosafras = true;
      try {
        const response = await this.$http.secured.get("/api/v1/anosafras", {
        });
        this.openAnosafras = response.data.anosafras;
        this.selectedAnosafra = this.openAnosafras[0];
      } catch (error) {}
      this.isLoadingOpenAnosafras = false;
    },
    getCultures(preferredproduct_id, page, side, filterLeft, filterRight) {
      if (typeof page === "undefined") page = null;
      var q = {};
      if (side === "left") {
        if (typeof filterLeft == "string" && filterLeft != "") {
          q.description = filterLeft;
        } else {
          q = null;
        }

        this.$http.secured
          .get("/api/v1/getleftculturespreferred", {
            params: {
              page: page,
              q: q,
              id: preferredproduct_id,
            },
          })
          .then((response) => {
            this.paginated_cultures_left = response.data;
            this.cultures = this.paginated_cultures_left["cultures"];
          })
          .catch((error) => this.setError(error, "Something went wrong"));
      }
      if (side === "right") {
        if (typeof filterRight == "string" && filterRight != "") {
          q.description = filterRight;
        } else {
          q = null;
        }
        this.$http.secured
          .get("/api/v1/getrightculturespreferred", {
            params: {
              id: preferredproduct_id,
              q: q,
              page: page,
            },
          })
          .then((response) => {
            this.paginated_cultures_right = response.data;
            this.rightItems = this.paginated_cultures_right["cultures"];
          })
          .catch((error) => this.setError(error, "Something went wrong"));
      }
    },
    showInactivateModal(preferredproduct) {
      this.formPreferredProduct = Object.assign({}, preferredproduct);
      this.modals.inactivateProduct = true;
      if (!this.openAnosafras || this.openAnosafras.length == 0)
        this.getOpenAnosafras();
    },
    async inactivate() {
      const response = await swal.fire({
        title: `Aviso!`,
        html: "As metas <b>apagadas</b> não poderão ser recuperadas!<br>Deseja prosseguir?",
        width: "650px",
        buttonsStyling: false,
        showConfirmButton: true,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonClass: "btn btn-warning",
        cancelButtonClass: "btn btn-default",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Inativar Produto Preferencial",
        icon: "warning",
        preConfirm: async () => {
          try {
            this.formPreferredProduct.inactivated_at = this.selectedAnosafra.update_start_date;
            await this.execEdit();
            return true;
          } catch (error) {
            console.log("error: ", error)
            swal.showValidationMessage(
              "Falha ao inativar Produto Preferencial"
            );
          }
        },
      });

      if (response.isConfirmed) {
        this.search();
        this.modals.inactivateProduct = false;
      }
    },
    async activate(preferredproduct) {

      this.formPreferredProduct = Object.assign({}, preferredproduct);
      this.formPreferredProduct.inactivated_at = null;

      const response = await swal.fire({
        title: `Reativar Produto`,
        html: "Deseja reativar este produto preferencial?",
        width: "650px",
        buttonsStyling: false,
        showConfirmButton: true,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-default",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Reativar",
        icon: "info",
        preConfirm: async () => {
          try {
            this.formPreferredProduct.inactivateactivated_at = this.selectedAnosafra.update_start_date;
            await this.execEdit(); 
            return true;
          } catch (error) {
            console.log("error: ", error);
            swal.showValidationMessage(
              "Falha ao reativar Produto Preferencial"
            );
          }
        },
      });

      if (response.isConfirmed) {
        this.search();
        this.modals.inactivateProduct = false;
      }
    },
    remove(preferredproduct) {
      if (
        confirm("Deseja excluir o Produto " + `${preferredproduct.name}` + "?")
      ) {
        this.$http.secured
          .delete(
            `/api/v1/preferredproducts/${preferredproduct.id}`,
            preferredproduct
          )
          .then((response) => {
            this.$toasted.global.defaultSuccess();
            this.setData();
          })
          .catch((error) =>
            this.setError(error, "Cannot delete preferredproduct")
          );
      }
    },

    async setProducts(side, q, page, filterRight) {
      this.loadingPickerProducts = true;
      const queryParams = this.filterProduct;
      queryParams.status = "active"
      queryParams.preferredproduct_id = side === "right" ? q : 0

      if (filterRight && filterRight.description) queryParams.description = filterRight.description;
      if (typeof page === "undefined") page = null;

      try {
        const response = await this.$http.secured.get("/api/v1/products", {
          params: {
            per_page: 11,
            page: page,
            q: queryParams,
          },
        });

        if (side === "right") {
          this.paginated_products_right = response.data;
          this.rightItems = this.paginated_products_right["products"];
        } else {
          this.paginated_products_left = response.data;
          this.products = this.paginated_products_left["products"];
        }

        if (side === "left" && queryParams.description) {
          const searchDescription = queryParams.description.trim().toUpperCase();
          const linkedProduct = response.data.products.find((product) => {
            const productDescription = product.description.trim().toUpperCase();
            return (
              productDescription === searchDescription &&
              product.preferredproduct_id && 
              product.preferredproduct_id !== queryParams.preferredproduct_id
            );
          });

          const result = `O produto filho "${linkedProduct.description}" já está vinculado a outro produto preferencial" ${linkedProduct.preferredproduct_name}"`
          
          if (!linkedProduct) return;

          swal.fire({
            title: "Atenção",
            text: result,
            icon: "",
            showCancelButton: true,
            showConfirmButton: false,
            confirmButtonText: "Ok",
            cancelButtonText: "Fechar",
            confirmButtonColor: "#61cf8a",
            cancelButtonColor: "#dc3545",
          });
          
          this.loadingPickerProducts = false;
          
          return;
        }
        
      } catch (error) {
        this.setError(error, "Something went wrong");
      } finally {
        this.loadingPickerProducts = false;
      }
    },
    adicionaraopp(pp_id, products) {
      let pp = this.preferredproducts.find((e) => e.id == pp_id);
      this.preferredproduct.products = this.rightItems;

      if (Array.isArray(products)) {
        products.forEach((product) => {
          product.preferredproduct_id = pp_id;
          this.$http.secured
            .put(`/api/v1/products/${product.id}`, product)
            .then((response) => {
              this.response = response.data;
            })
            .catch((error) => this.setError(error, "Cannot update Product"));
        });
        this.setProducts("left", this.filterProduct);
        this.setProducts("right", pp_id);
      } else {
        products.preferredproduct_id = pp_id;
        this.$http.secured
          .put(`/api/v1/products/${products.id}`, products)
          .then((response) => {
            this.response = response.data;
            this.setProducts("left", this.filterProduct);
            this.setProducts("right", pp_id);
          })
          .catch((error) => this.setError(error, "Cannot update Product"));
      }
    },
    removerdopp(pp_id, products) {
      let pp = this.preferredproducts.find((e) => e.id == pp_id);
      this.preferredproduct.products = this.rightItems;
      if (Array.isArray(products)) {
        products.forEach((product) => {
          product.preferredproduct_id = null;
          this.$http.secured
            .put(`/api/v1/products/${product.id}`, product)
            .then((response) => {
              this.response = response.data;
            })
            .catch((error) =>
              this.setError(error, "Cannot update PreferredProduct")
            );
        });
        this.setProducts("left", this.filterProduct);
        this.setProducts("right", pp_id);
      } else {
        products.preferredproduct_id = null;
        this.$http.secured
          .put(`/api/v1/products/${products.id}`, products)
          .then((response) => {
            this.response = response.data;
            this.setProducts("left", this.filterProduct);
            this.setProducts("right", pp_id);
          })
          .catch((error) =>
            this.setError(error, "Cannot update PreferredProduct")
          );
      }
    },
     changePageRightCultures(preferredproduct, page, filter) {
      if(filter){
        this.getCultures(preferredproduct, page, 'right', null , filter);
      }else{
        this.getCultures(preferredproduct, page, 'right', null, "");
      }
    },
    changePageLeftCultures(preferredproduct, page, filter) {
      if(filter){
        this.getCultures(preferredproduct, page, 'left', filter, null);
      }else{
        this.getCultures(preferredproduct, page, 'left', "", null);
      }
    },
    changePageLeft(page) {
      this.setProducts("left", this.filterProduct, page);
    },
    changePageRight(preferredproduct_id, page) {
      this.setProducts("right", preferredproduct_id, page);
    },
    searchEventLeft(pesquisa) {
      if (pesquisa === this.filterProduct.description) return;
      if (this.searchEventLeftTimeout) clearTimeout(this.searchEventLeftTimeout);

      this.searchEventLeftTimeout = setTimeout(() => {
        this.filterProduct.description = pesquisa;
        this.setProducts("left", this.filterProduct, null);
      }, 700);
    },
    searchEventLeftCultures(search, preferredproduct) {
      this.filterCultures = search;
      this.getCultures(preferredproduct, undefined, 'left', search, null);
    },
    searchEventRightCultures(search, preferredproduct){
      this.filterCulturesRight = search;
      this.getCultures(preferredproduct, undefined, 'right', null, search)
    },
    searchEventRight(pesquisa, preferredproduct) {
      if (this.searchEventRightTimeout) clearTimeout(this.searchEventRightTimeout);

      this.searchEventRightTimeout = setTimeout(() => {
        this.filterRight.description = pesquisa;
        this.setProducts("right", preferredproduct, undefined, this.filterRight);
      }, 500);
    },
    onTouch(campo) {
      switch (campo) {
        case "group":
          this.isTouchedGroup = true;
          break;
        case "subgroup":
          this.isTouchedSubgroup = true;
          break;
      }
    },
    async updateClonePreferredproducts(query) {
      this.form.clone.isLoading = true;
      try {
        const response = await this.$http.secured.get("/api/v1/products", {
          params: {
            per_page: 10,
            q: { description: query},
          },
        });
        this.form.clone.products = response.data.products;
      } catch (error) {}

      this.form.clone.isLoading = false;
    },
    cloneProduct(selectedOption, _id) {
      this.preferredproduct = Object.assign({}, this.preferredproduct, {
        name: selectedOption.description,
        brand: selectedOption.product_brand,
        grupo: selectedOption.grupo,
        subgrupo: selectedOption.subgrupo,
        grupo_id: selectedOption.grupo && selectedOption.grupo.id,
        subgrupo_id: selectedOption.subgrupo && selectedOption.subgrupo.id,
        brand_id: selectedOption.product_brand && selectedOption.product_brand.id
      });
    },
    unityVolumeTranslator(unity) {
      if (!unity) return "Não Definido";

      if (["K", "GL", "SC", "FR", "LT", "KG", "L", "BD"].includes(unity.toUpperCase())) return "KG/LT";
      if (unity.toUpperCase() == "D") return "DOSE";
      if (unity.toUpperCase() == "M") return "MX";
      if (["U", "UN"].includes(unity.toUpperCase())) return "UNIDADE";

      return "Não Definido";
    },
    editProduct(product) {
      this.form.product = product;
      this.modals.productEdition = true;
    },
    async saveProduct() {
      this.isSaving = true;
      try {
        await this.$http.secured.put(
          `/api/v1/products/${this.form.product.id}`,
          this.form.product
        );
        this.modals.productEdition = false;
      } catch (error) {}
      this.isSaving = false;
    },
    clearFilters() {
      this.filter.idObj = "",
      this.filter.name = "",
      this.filter.selectedStatus = { label: "Ativo", value: "active" },
      this.brandObj = null,
      this.filter.grupo = "",
      this.filter.subgrupo = ""

      this.search();
    },
    async getPreferredProduct(id) {
      try {
        return await this.$http.secured.get(`/api/v2/preferredproducts/${id}`);
      } catch (error) {
        this.openGoBackModal = true
      }
    },
    async initRouteProduct(preferredProductId) {
      this.isLoading = true;
      this.setFilterPreferredProducts()
      const response = await this.getPreferredProduct(preferredProductId)
      this.isLoading = false;

      if (!response) return;

      const preferredProduct = response.data
      this.filter.idObj      = preferredProduct

      this.search()
    }
  },
  computed: {
    ...mapState({
      notificationAssociableId: state => state.notificationAssociableId
    }),
    subGroupIsInvalid() {
      return this.isTouchedSubgroup && !this.preferredproduct.subgrupo_id;
    },
    groupIsInvalid() {
      return this.isTouchedGroup && !this.preferredproduct.grupo_id;
    },
    emptyFilter: function () {
      let permanentValues = ["grupo", "subgrupo", "brandObj", "idObj"];
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined" &&
          !permanentValues.includes(key)
        ) {
          return false;
        }
      }
      return true;
    },
    formProductUnity: {
      get() {
        if (!(this.form.product || this.form.product.unity_type)) return {};

        return this.unityTypes.find(
          (o) => o.code == this.form.product.unity_type || o.otherOptions && o.otherOptions.includes(this.form.product.unity_type)
        );
      },
      set(newUnity) {
        this.form.product.unity_type = newUnity.code;
      },
    },
    formProductStatus: {
      get() {
        if (!(this.form.product || this.form.product.status)) return false;

        return this.form.product.status == "active";
      },
      set(newVal) {
        this.$set(
          this.form.product,
          "status",
          newVal === true ? "active" : "inactive"
        );
      },
    },
  },
  mounted() {
    this.updateClonePreferredproducts("");
    this.filter.selectedStatus = this.filterStatuses.find(
      (status) => status.value === "active"
    );
  },
  watch: {
    "formPreferredProduct.subgrupo": function (newSubgrupo) {
      if (!newSubgrupo) return;
      this.formPreferredProduct.subgrupo_id = newSubgrupo.id;
    },
    "formPreferredProduct.grupo": function (newGrupo) {
      if (!newGrupo) return;
      this.formPreferredProduct.grupo_id = newGrupo.id;
    },
    notificationAssociableId: function (newValue) {
      if (newValue) {
        this.initRouteProduct(newValue);
        this.resetNotificationAction(); // Reset the state to avoid multiple triggers
      }
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style>
.tab-pane {
  padding: 10px;
}
.list-picker-selected {
  background: #61cf8a !important;
}
.button-class {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
  margin-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 50% !important;
}

.button-class img {
  filter: invert(100%);
}

.list-picker-container {
  border-width: 10px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  border-radius: 12px !important;
}

.list-picker-panel {
  border: 1px solid;
  border-color: #ccc;
  border-top: 3px solid;
  border-top-color: #61cf8a;
}

.tituloGrupos {
  background-color: #61cf8a !important;
  box-sizing: border-box !important;
  color: rgb(255, 255, 255) !important;
  display: inline-block !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  height: 30px !important;
  line-height: 17px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 7px !important;
  text-align: left !important;
  text-size-adjust: 100% !important;
  visibility: visible !important;
  /* width: 35% !important; */
  border-radius: 6px 6px 0px 0px;
  border-bottom: 0px !important;
}
.inputLeft {
  width: 97%;
}
.inputRight {
  float: right;
  width: 89%;
}
.tagproduto {
  margin-left: 3px !important;
  margin-bottom: 3px !important;
}
</style>
